import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import PageLoader from '../template/PageLoader';
import { Footer } from '../template/Footer';
import LocationSidebar from '../template/LocationSidebar';

const NearestLocationLayout = () => {

  return (
    <div className='flex'>
      <LocationSidebar />
      <div className="flex flex-col flex-auto min-h-screen min-w-0 relative w-full">
        <div className={'h-full flex flex-auto flex-col justify-between'}>
          <Suspense fallback={<PageLoader />}>
            <main className="relative h-full flex flex-auto flex-col container">
              <Outlet />
            </main>
          </Suspense>
        </div>
        <Footer/>
      </div>
    </div>
    
  );
};

export default NearestLocationLayout;

